import { useRef, useEffect, useState } from "react";
import { Divider } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import numberToWords from "number-to-words";
import { useNavigate, useLocation } from "react-router";
import QrCodeGenerator from "views/commonComponents/QrCode/QrCodeGenerator";
import { useSelector } from "react-redux";

function A4PrintTaxVAt() {
  const componentRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const { data, tableData, qrData, typ } = location.state;
  console.log(qrData,"qrqrqrqrqrqr")
  const company = useSelector((state) => state.common.companyInfo);
  const companyLogo = company.logo ? JSON.parse(company.logo)?.img : null;
  const decimalCount = useSelector((state) => state.common.decimalCount);
  const primaryCurrency = useSelector((state) => state.common.primaryCurrency);
  const subCurrency = useSelector((state) => state.common.subCurrency);
  const taxUtilitiesListData = useSelector(
    (state) => state.common.taxUtilitiesListData,
  );

  const [pages, setPages] = useState([]);
  const [calculated, setCalculated] = useState(false);
  const [rowHeights, setRowHeights] = useState([]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      navigate(-2);
    },
  });
  console.log(data, "fulldata");

  useEffect(() => {
    const calculateRowHeights = () => {
      const heights = tableData.map((item) => {
        const description = item.ItemNameTextField || "";
        const lineHeight = 16;
        const maxWidth = 250;
        const avgCharsPerLine = maxWidth / 7;
        const lines = Math.ceil(description.length / avgCharsPerLine);
        return Math.max(35, lines * lineHeight);
      });
      setRowHeights(heights);
    };

    calculateRowHeights();
  }, [tableData]);

  useEffect(() => {
    const calculatePages = () => {
      if (rowHeights.length === 0) return;

      const pageHeight = 1040; // A4 height in pixels
      const headerHeight = 300; // Actual header height from your renderHeader
      const footerHeight = 320; // Actual footer height from your renderFooter
      const availableHeight = pageHeight - headerHeight - footerHeight;

      console.log("Available height for table rows:", availableHeight);

      const newPages = [];
      let currentPage = [];
      let currentHeight = 0;

      const tableHeaderHeight = 60; // Approximate table header height

      rowHeights.forEach((height, index) => {
        const rowHeightWithBuffer = height + 2;

        // If adding this row would exceed available height, start new page
        if (currentHeight + rowHeightWithBuffer > availableHeight) {
          if (currentPage.length > 0) {
            newPages.push(currentPage);
          }
          currentPage = [index];
          currentHeight = tableHeaderHeight + rowHeightWithBuffer;
        } else {
          // First row on page needs to include table header height
          if (currentPage.length === 0) {
            currentHeight = tableHeaderHeight + rowHeightWithBuffer;
          } else {
            currentHeight += rowHeightWithBuffer;
          }
          currentPage.push(index);
        }
      });

      // Don't forget the last page
      if (currentPage.length > 0) {
        newPages.push(currentPage);
      }

      console.log("Calculated pages:", newPages);
      console.log("Total items:", rowHeights.length);
      console.log(
        "Items per page:",
        newPages.map((page) => page.length),
      );

      setPages(newPages);
      setCalculated(true);
    };

    if (rowHeights.length > 0) {
      calculatePages();
    }
  }, [rowHeights]);

  useEffect(() => {
    if (company && calculated) {
      const timeoutId = setTimeout(() => {
        handlePrint();
      }, 100);

      return () => clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, calculated]);

  function convertNumberToWordsWithCurrency(number) {
    const paisaAmount = ((number || 0) * 100) % 100;
    const words = numberToWords?.toWords(Math?.floor(number || 0));
    const paisaInWords = numberToWords?.toWords(paisaAmount);
    return `${words} ${primaryCurrency} and  ${paisaInWords} ${subCurrency}`;
  }

  const amount =
    typ === "PR" || typ === "PB" ? data.NTot : data.BillNetTotalField;
  const result = convertNumberToWordsWithCurrency(amount);

  const generateSections = () => {
    return pages.map((pageIndices, pageIndex) => {
      const sectionItems = pageIndices.map((index) => ({
        ...tableData[index],
        printSino: index + 1,
      }));
      return renderSection(sectionItems, pageIndex, pageIndex > 0);
    });
  };

  const renderHeader = () => {
    return (
      <div
        style={{
          border: "1px solid #8c8b8b",
          padding: "5px",
          minHeight: "280px",
          height: "auto",
          boxSizing: "border-box",
        }}
      >
        {/* Your header content remains the same */}
        <div
          style={{
            justifyContent: "space-between",
            display: "flex",
            padding: "5px",
          }}
        >
          <div>
            <div style={{ fontWeight: "bold" }}>{company?.Name}</div>
            <div style={{ fontWeight: 600 }}>{company?.Place}</div>
            <div>{company?.Add1}</div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "50%",
                }}
              >
                <div>CR</div>
                <div>:</div>
              </div>
              <div style={{ width: "50%", paddingLeft: "3px" }}>
                {company?.additional_no}
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "50%",
                }}
              >
                <div>VAT No</div>
                <div>:</div>
              </div>
              <div style={{ width: "50%", paddingLeft: "3px" }}>
                {company?.Add2}
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "50%",
                }}
              >
                <div>Phone</div>
                <div>:</div>
              </div>
              <div style={{ width: "50%", paddingLeft: "3px" }}>
                {company?.Ph}
              </div>
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "flex-end",
              fontWeight: "bold",
              gap: "5px",
            }}
          >
            <div style={{ width: "150px", height: "100px" }}>
              {companyLogo && (
                <img
                  alt="Logo"
                  style={{ width: "100%", height: "100%" }}
                  src={companyLogo}
                />
              )}
            </div>
            <div>
              {typ === "SB" ? (
                <div style={{ display: "flex", gap: "5px", fontSize: "16px" }}>
                  <div>VAT INVOICE</div>
                  <div>فاتورة ضريبة</div>
                </div>
              ) : typ === "SR" ? (
                <div style={{ display: "flex", gap: "5px", fontSize: "16px" }}>
                  <div>SALES RETURN</div>
                  <div>عائد المبيعات</div>
                </div>
              ) : typ === "PB" ? (
                <div style={{ display: "flex", gap: "5px", fontSize: "16px" }}>
                  <div>PURCHASE BILL</div>
                  <div> فاتورة الشراء</div>
                </div>
              ) : typ === "OF" ? (
                <div style={{ display: "flex", gap: "5px", fontSize: "16px" }}>
                  <div>QUOTATION</div>
                  <div>اقتباس</div>
                </div>
              ) : typ === "B2C" ? (
                <div style={{ display: "flex", gap: "5px", fontSize: "16px" }}>
                  <div>SIMPLIFIED TAX INVOICE</div>
                  <div> فاتورة ضريبية مبسطة </div>
                </div>
              ) : (
                <div style={{ display: "flex", gap: "5px", fontSize: "16px" }}>
                  <div>PURCHASE RETURN</div>
                  <div> عودة شراء</div>
                </div>
              )}
            </div>
          </div>
          <div style={{ width: "180px" }}>
            <div style={{ textAlign: "right", fontWeight: "bold" }}>
              {company?.name_ar}
            </div>
            <div style={{ textAlign: "right", fontWeight: 600 }}>
              {company?.building_no_ar}
            </div>
            <div style={{ textAlign: "right" }}>
              {`${company?.street_ar} ${company.city_ar} `}
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "50%",
                  paddingRight: "3px",
                  textAlign: "right",
                }}
              >
                {company?.additional_no_ar}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "50%",
                }}
              >
                <div>:</div>
                <div>CR</div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "50%",
                  paddingRight: "3px",
                  textAlign: "right",
                }}
              >
                {company?.tax_no_ar}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "50%",
                }}
              >
                <div>:</div>
                <div>VAT No</div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "50%",
                  paddingRight: "3px",
                  textAlign: "right",
                }}
              >
                {company?.whatsapp_no}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "50%",
                }}
              >
                <div>:</div>
                <div>Phone</div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%", padding: "5px" }}>
          <table
            style={{
              borderCollapse: "collapse",
              border: "1px solid #8c8b8b",
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                {/* To */}
                <th style={{ border: "1px solid #8c8b8b", width: "120px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "3px",
                      fontSize: "14px",
                    }}
                  >
                    <div>To</div>
                    <div>لى</div>
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "start",
                    border: "1px solid #8c8b8b",
                    fontSize: "14px",
                    padding: "3px",
                    width: "calc(50% - 120px)",
                  }}
                >
                  {data?.BillPartyName}
                </th>
                {/* INVOICE NO */}
                <th style={{ border: "1px solid #8c8b8b", width: "170px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "3px",
                      fontSize: "12px",
                    }}
                  >
                    <div>INVOICE NO</div>
                    <div>رقم الفاتورة </div>
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "start",
                    border: "1px solid #8c8b8b",
                    fontSize: "14px",
                    padding: "3px",
                    width: "calc(50% - 170px)",
                  }}
                >
                  {data?.BillNo}
                </th>
              </tr>
              <tr>
                {/* Address */}
                <th style={{ border: "1px solid #8c8b8b", width: "120px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "3px",
                      fontSize: "14px",
                    }}
                  >
                    <div>Address</div>
                    <div>عنوان</div>
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "start",
                    border: "1px solid #8c8b8b",
                    fontSize: "14px",
                    padding: "3px",
                  }}
                >
                  {data?.warranty}
                </th>
                {/* INVOICE DATE */}
                <th style={{ border: "1px solid #8c8b8b", width: "170px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "3px",
                      fontSize: "12px",
                    }}
                  >
                    <div>INVOICE DATE</div>
                    <div>تاريخ</div>
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "start",
                    border: "1px solid #8c8b8b",
                    fontSize: "14px",
                    padding: "3px",
                  }}
                >
                  <div
                    style={{
                      justifyContent: "space-evenly",
                      display: "flex",
                    }}
                  >
                    <div>
                      {new Date(data?.BillDate).toLocaleDateString("en-US", {
                        year: "2-digit",
                        month: "numeric",
                        day: "numeric",
                      })}
                    </div>
                    <div>
                      {new Date(data?.BillDate).toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                {/* VAT No. */}
                <th style={{ border: "1px solid #8c8b8b", width: "120px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "3px",
                      fontSize: "14px",
                    }}
                  >
                    <div>VAT No.</div>
                    <div></div>
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "start",
                    border: "1px solid #8c8b8b",
                    fontSize: "14px",
                    padding: "3px",
                  }}
                >
                  {data?.TinNo || data?.vat_no || data?.vatNo}
                </th>
                {/* Remarks */}
                <th style={{ border: "1px solid #8c8b8b", width: "170px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "3px",
                      fontSize: "12px",
                    }}
                  >
                    <div>Remarks</div>
                    <div>ملاحظات</div>
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "start",
                    border: "1px solid #8c8b8b",
                    fontSize: "14px",
                    padding: "3px",
                  }}
                ></th>
              </tr>
              <tr>
                {/* Ph */}
                <th style={{ border: "1px solid #8c8b8b", width: "120px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "3px",
                      fontSize: "14px",
                    }}
                  >
                    <div>Ph</div>
                    <div>جوال</div>
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "start",
                    border: "1px solid #8c8b8b",
                    fontSize: "14px",
                    padding: "3px",
                  }}
                >
                  {data?.Ph}
                </th>
                {/* Empty cells to complete row structure */}
                <th
                  style={{ border: "1px solid #8c8b8b", width: "170px" }}
                ></th>
                <th style={{ border: "1px solid #8c8b8b" }}></th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderFooter = (isLastPage = true) => {
    return (
      <div
        style={{
          minHeight: isLastPage ? "300px" : "auto",
          height: "auto",
          width: "100%",
          pageBreakBefore: "avoid",
          pageBreakInside: "avoid",
          marginTop: "auto",
        }}
      >
        {isLastPage ? (
          <>
            <div
              style={{
                display: "flex",
            width: "100%",
            borderTop: "1px solid #8c8b8b",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div style={{ width: "150px" }}>
            {(data?.zatca_einv_qr_code || qrData) && (
              <QrCodeGenerator qrData={data?.zatca_einv_qr_code || qrData} />
            )}
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "end",
              padding: "10px",
              justifyContent: "flex-end",
            }}
          >
            <table style={{ lineHeight: "28px" }}>
              <tbody>
                <tr>
                  <td>
                    <div
                      style={{
                        width: "550px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "140px",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        Total Excld. VAT
                      </div>
                      <div
                        style={{
                          width: "140px",
                          textAlign: "end",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        الإجمالي غير شامل ضريبة :
                      </div>
                      <div
                        style={{
                          width: "140px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {(() => {
                          let targetTyp = "";
                          if (typ === "PB") targetTyp = "PURCHASE";
                          else if (typ === "PR") targetTyp = "PURCHASE_RETURN";
                          else if (typ === "SR") targetTyp = "SALES_RETURN";
                          else targetTyp = "SALES_B2B_AND_B2C";

                          let taxIncluded = false;
                          if (
                            taxUtilitiesListData &&
                            taxUtilitiesListData.length > 0
                          ) {
                            const config = taxUtilitiesListData.find(
                              (item) =>
                                item.typ === targetTyp ||
                                item.Typ === targetTyp,
                            );
                            taxIncluded =
                              config?.Nam === "YES" || config?.value === "YES";
                          } else {
                            // Fallback if Redux is empty (e.g. after a page refresh on the print route)
                            if (typ === "PR" || typ === "PB") {
                              taxIncluded =
                                Number(data?.Total).toFixed(decimalCount) ===
                                Number(data?.NTot).toFixed(decimalCount);
                            } else {
                              taxIncluded =
                                Number(data?.BillTotalField).toFixed(
                                  decimalCount,
                                ) ===
                                Number(data?.BillNetTotalField).toFixed(
                                  decimalCount,
                                );
                            }
                          }

                          if (typ === "PR" || typ === "PB") {
                            return taxIncluded
                              ? (data?.Total - data?.TItTaxAmt).toFixed(
                                  decimalCount,
                                )
                              : (data?.Total).toFixed(decimalCount);
                          } else {
                            return taxIncluded
                              ? (
                                  data?.BillTotalField - data?.TItTaxAmt
                                ).toFixed(decimalCount)
                              : (data?.BillTotalField).toFixed(decimalCount);
                          }
                        })()}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        width: "550px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          width: "140px",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        Discount
                      </div>
                      <div
                        style={{
                          width: "140px",
                          textAlign: "end",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        الخصـم :
                      </div>
                      <div
                        style={{
                          width: "140px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {typ === "PR" || typ === "PB"
                          ? data.DiscAmt?.toFixed(decimalCount)
                          : data?.BillDiscAmtField?.toFixed(decimalCount)}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        width: "550px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          width: "140px",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        Vat {company?.tax === 0 ? null : company?.tax}%
                      </div>
                      <div
                        style={{
                          width: "140px",
                          textAlign: "end",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        ضريبة القيمة المضافة{" "}
                        {company?.tax === 0 ? null : company?.tax}%:
                      </div>
                      <div
                        style={{
                          width: "140px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {typ === "PR" || typ === "PB"
                          ? data?.Tax.toFixed(decimalCount)
                          : data?.TItTaxAmt.toFixed(decimalCount)}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        width: "550px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          width: "140px",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        Total Amt (Incl.VAT)
                      </div>
                      <div
                        style={{
                          width: "140px",
                          textAlign: "end",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        الإجمالي شامل ضريبة :
                      </div>
                      <div
                        style={{
                          width: "140px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {typ === "PR" || typ === "PB"
                          ? data.NTot.toFixed(decimalCount)
                          : parseFloat(data?.BillNetTotalField).toFixed(
                              decimalCount,
                            )}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: "14px" }}>Salesman Signature</div>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              توقيع البائع
            </div>
            <div style={{ paddingTop: "10px" }}>
              ..................................
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ fontSize: "14px" }}>Amount in Words : {result}</div>
          </div>
          <div>
            <div style={{ fontSize: "14px" }}>Reciever's Signature</div>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              توقيع المستلم
            </div>
            <div style={{ paddingTop: "10px" }}>
              ...................................
            </div>
          </div>
        </div>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "10px 15px",
              borderTop: "1px solid #8c8b8b",
              fontSize: "13px",
              color: "#555",
            }}
          >
            <div>Continued on next page...</div>
            <div>...تابع في الصفحة التالية</div>
          </div>
        )}
        <div style={{ background: "#000099", color: "white" }}>
          <div
            style={{ textAlign: "center", padding: "10px", fontWeight: 500 }}
          >
            <div style={{ fontWeight: "bold", fontSize: "14px" }}>
              {`${company?.name_ar} ${company?.building_no_ar} ${company?.street_ar} ${company?.city_ar} `}
            </div>
            <div style={{ fontSize: "14px" }}>
              {`${company?.Name} ${company?.Place}`}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSection = (sectionItems, sectionIndex, isContinued) => {
    const isLastPage = sectionIndex === pages.length - 1;
    return (
      <div
        key={`section-${sectionIndex}`}
        style={{
          pageBreakBefore: isContinued ? "always" : "auto",
          height: "1040px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #ccc",
          marginBottom: "1rem",
          boxSizing: "border-box",
          position: "relative",
        }}
      >
        {/* Header - No gap after this */}
        {renderHeader()}

        {/* Table Section - Starts immediately after header with NO GAP */}
        <div
          style={{
            flex: "1",
            minHeight: "0",
            overflow: "hidden",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
              marginTop: "0px", // Ensure no margin
              borderSpacing: "0px", // Remove any table spacing
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    textAlign: "left",
                    border: "1px solid #8c8b8b",
                    padding: "0.4rem",
                    width: "5%",
                    fontSize: "12px",
                    borderTop: "none", // Remove top border to eliminate visual gap
                  }}
                >
                  <div>SI NO</div>
                  <div>صيني</div>
                </th>
                <th
                  style={{
                    textAlign: "left",
                    border: "1px solid #8c8b8b",
                    padding: "0.4rem",
                    width: "35%",
                    fontSize: "12px",
                    borderTop: "none", // Remove top border to eliminate visual gap
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>Description</div>
                    <div>البـيــــــــــــان</div>
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    border: "1px solid #8c8b8b",
                    padding: "0.4rem",
                    width: "6%",
                    fontSize: "12px",
                    borderTop: "none", // Remove top border to eliminate visual gap
                  }}
                >
                  <div>Qty</div>
                  <div>الكمية</div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    border: "1px solid #8c8b8b",
                    padding: "0.4rem",
                    width: "8%",
                    fontSize: "12px",
                    borderTop: "none", // Remove top border to eliminate visual gap
                  }}
                >
                  <div>Rate</div>
                  <div>السعر</div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    border: "1px solid #8c8b8b",
                    padding: "0.4rem",
                    width: "6%",
                    fontSize: "12px",
                    borderTop: "none", // Remove top border to eliminate visual gap
                  }}
                >
                  <div>Unit</div>
                  <div>وحدة</div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    border: "1px solid #8c8b8b",
                    padding: "0.4rem",
                    width: "8%",
                    fontSize: "12px",
                    borderTop: "none", // Remove top border to eliminate visual gap
                  }}
                >
                  <div>Amount</div>
                  <div>كمية</div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    border: "1px solid #8c8b8b",
                    padding: "0.4rem",
                    width: "6%",
                    fontSize: "12px",
                    borderTop: "none", // Remove top border to eliminate visual gap
                  }}
                >
                  <div>Tax%</div>
                  <div>نسبة الضريبة</div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    border: "1px solid #8c8b8b",
                    padding: "0.4rem",
                    width: "8%",
                    fontSize: "12px",
                    borderTop: "none", // Remove top border to eliminate visual gap
                  }}
                >
                  <div>Tax</div>
                  <div>ضريبة</div>
                </th>
                <th
                  style={{
                    textAlign: "right",
                    border: "1px solid #8c8b8b",
                    padding: "0.4rem",
                    width: "8%",
                    fontSize: "12px",
                    borderTop: "none", // Remove top border to eliminate visual gap
                  }}
                >
                  <div>Total</div>
                  <div>المجموع</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {sectionItems.map((prod, index) => (
                <tr
                  key={index}
                  style={{
                    height: `${rowHeights[prod.printSino - 1]}px` || "auto",
                    pageBreakInside: "avoid",
                  }}
                >
                  <td
                    style={{
                      textAlign: "center",
                      border: "1px solid #8c8b8b",
                      verticalAlign: "top",
                      padding: "4px",
                      fontSize: "12px",
                    }}
                  >
                    {prod.printSino}
                  </td>
                  <td
                    style={{
                      textAlign: "left",
                      border: "1px solid #8c8b8b",
                      padding: "4px",
                      wordWrap: "break-word",
                      verticalAlign: "top",
                      fontSize: "11px",
                    }}
                  >
                    {prod.ItemNameTextField}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      border: "1px solid #8c8b8b",
                      verticalAlign: "top",
                      padding: "4px",
                      fontSize: "12px",
                    }}
                  >
                    {prod.qty}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      border: "1px solid #8c8b8b",
                      verticalAlign: "top",
                      padding: "4px",
                      fontSize: "12px",
                    }}
                  >
                    {typ === "PR" || typ === "PB"
                      ? parseFloat(prod.Cost).toFixed(decimalCount)
                      : parseFloat(prod.Rate1).toFixed(decimalCount)}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      border: "1px solid #8c8b8b",
                      verticalAlign: "top",
                      padding: "4px",
                      fontSize: "12px",
                    }}
                  >
                    {prod.Typ}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      border: "1px solid #8c8b8b",
                      verticalAlign: "top",
                      padding: "4px",
                      fontSize: "12px",
                    }}
                  >
                    {typ === "PR" || typ === "PB"
                      ? (prod.Cost * prod.qty).toFixed(decimalCount)
                      : (prod.Rate1 * prod.qty).toFixed(decimalCount)}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      border: "1px solid #8c8b8b",
                      verticalAlign: "top",
                      padding: "4px",
                      fontSize: "12px",
                    }}
                  >
                    {prod.Tax1}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      border: "1px solid #8c8b8b",
                      verticalAlign: "top",
                      padding: "4px",
                      fontSize: "12px",
                    }}
                  >
                    {parseFloat(prod.taxAmt).toFixed(decimalCount)}
                  </td>
                  <td
                    style={{
                      textAlign: "right",
                      border: "1px solid #8c8b8b",
                      verticalAlign: "top",
                      padding: "4px",
                      fontSize: "12px",
                    }}
                  >
                    {prod.total.toFixed(decimalCount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer - Space will appear between table and footer when needed */}
        {renderFooter(isLastPage)}
      </div>
    );
  };

  const sections = generateSections();

  return (
    <div>
      <div
        ref={componentRef}
        style={{
          background: "white",
          height: "auto",
        }}
      >
        {sections}
      </div>
    </div>
  );
}

export default A4PrintTaxVAt;
